import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

// UTILS
import { Utils } from 'utils/Utils'
import { UtilsHTML } from 'utils/html'
import { isCustomerEditBooking } from 'utils/new_booking/common'
import I18n from 'i18n/i18n'
// ACTIONS
import * as extraServiceActionCreators from 'store/actions/new_booking/extraServiceActionCreators'
import * as editModeTextActionCreators from 'store/actions/new_booking/editModeTextActionCreators'
import { currentPopupIDActionsCreator } from 'store/toolkit/currentPopupID/currentPopupID.reducer'
import { infoAssignDriverPopupActionsCreator } from 'store/toolkit/infoAssignDriverPopup/infoAssignDriverPopup.reducer'
// COMPONENTS
// CONSTANTS
// ASSETS

const mapStateToProps = state => ({
  assignedDriver: state.assignedDriver,
  badges: state.extraServices.companyBadges,
  extraInfos: state.extraInfos,
})

function mapDispatchToProps(dispatch) {
  return {
    extraServiceActions: bindActionCreators(extraServiceActionCreators, dispatch),
    currentPopupIDActions: bindActionCreators(currentPopupIDActionsCreator, dispatch),
    infoAssignDriverPopupActions: bindActionCreators(infoAssignDriverPopupActionsCreator, dispatch),
    editModeTextActions: bindActionCreators(editModeTextActionCreators, dispatch),
  }
}

class BadgeForCompany extends React.Component {
  constructor(props) {
    super(props)
  }

  onChangeCheckBox(id, event) {
    const { assignedDriver, currentPopupIDActions, infoAssignDriverPopupActions } = this.props
    const selected = event.target.checked
    if (assignedDriver) {
      Utils.updateInfoAssignDriverPopupActions(
        {
          func: this.onChangeCheckBoxAfterCheckBookingDetails.bind(this, id, selected),
        },
        currentPopupIDActions,
        infoAssignDriverPopupActions
      )
    } else {
      this.onChangeCheckBoxAfterCheckBookingDetails(id, selected)
    }
  }

  onChangeCheckBoxAfterCheckBookingDetails(id, selected) {
    const { extraServiceActions } = this.props
    const selectedAmount = selected ? 1 : 0
    extraServiceActions.updateCompanyBadge(id, { selected, selected_amount: selectedAmount })
  }

  onClickCebDisableCheckbox() {
    const { editModeTextActions } = this.props
    editModeTextActions.updateEditModeText(I18n.t('webapp.new_booking.step_2.company_badges'))
  }

  renderCheckbox(badge) {
    const enabledCustomerEditBooking = isCustomerEditBooking()
    const enableOption = enabledCustomerEditBooking ? false : badge.can_toggle
    const disabled = enableOption ? '' : 'Disable'
    const fieldName = `booking[booking_badges_with_deleted_attributes][${badge.id}]`
    return (
      <div className="block-item" key={badge.id}>
        <label htmlFor={`${enabledCustomerEditBooking ? '' : `badge_${badge.id}`}`} className="default-font">
          <div className="TitleSubtitle">
            <div className="TitleSubtitle-title">
              {badge.name}
            </div>
            <div className="TitleSubtitle-subtitle">—</div>
          </div>
        </label>
        <div className="block-item-action">
          <div className={`Overlay-Checkbox With-Icon Green-Checkbox ${disabled}`}>
            {
              enabledCustomerEditBooking
              && (
                <div
                  className="Ceb-disable-field Disable-checkbox-overlay"
                  onClick={() => this.onClickCebDisableCheckbox()}
                />
              )
            }
            <input
              type="checkbox"
              disabled={disabled}
              name={`${fieldName}[selected_amount]`}
              id={`badge_${badge.id}`}
              value="1"
              checked={badge.selected}
              onChange={this.onChangeCheckBox.bind(this, badge.id)} />
            <label>
              <i className="b material-icons Icon">check</i>
            </label>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { badges } = this.props
    if (_.isEmpty(badges)) {
      return <span />
    }
    return (
      <div>
        {UtilsHTML.renderOptionTitle(I18n.t('webapp.new_booking.step_2.company_badges'))}
        <div className="Badges block">
          {badges.map(badge => this.renderCheckbox(badge))}
        </div>
      </div>
    )
  }
}

BadgeForCompany.defaultProps = {
  assignedDriver: undefined,
}

BadgeForCompany.propTypes = {
  assignedDriver: PropTypes.shape({}),
  extraServiceActions: PropTypes.shape({}).isRequired,
  currentPopupIDActions: PropTypes.shape({}).isRequired,
  infoAssignDriverPopupActions: PropTypes.shape({}).isRequired,
  editModeTextActions: PropTypes.shape({}).isRequired,
  extraInfos: PropTypes.shape({}).isRequired,
  badges: PropTypes.arrayOf(PropTypes.shape({}))
}

export default connect(mapStateToProps, mapDispatchToProps)(BadgeForCompany)
